export const ADMIN_PROFILE_ID = 0;
